import { render } from "./about.vue?vue&type=template&id=074a31fb&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=074a31fb&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074a31fb"]])

export default __exports__